import { types } from 'mobx-state-tree';

const RouteFormModel = types.model({
  id: types.maybe(types.string),
  visible: types.boolean,
  startDate: types.maybe(types.string),
});

// What the user was trying to do when they were asked to create a template, so
// the subflow can resume that path once one exists.
export const TemplateSetupIntents = ['autoCreate', 'addFromTemplates'] as const;
export type TemplateSetupIntent = typeof TemplateSetupIntents[number];

const Route = types.model('Route')
  .props({
    routeFormModal: types.optional(RouteFormModel, { visible: false }),
    showRouteTemplatesModal: types.optional(types.boolean, false),
    templateSetupIntent: types.maybe(types.enumeration('TemplateSetupIntent', [...TemplateSetupIntents])),
    hoveredShiftID: types.optional(types.string, ''),
  })
  .actions((self) => ({
    openTemplateSetupModal(intent: TemplateSetupIntent) {
      self.templateSetupIntent = intent;
    },
    closeTemplateSetupModal() {
      self.templateSetupIntent = undefined;
    },
    openRouteFormModal(id?: string, startDate?: string) {
      self.routeFormModal = { id, visible: true, startDate };
    },
    closeRouteFormModal() {
      self.routeFormModal = { id: undefined, visible: false, startDate: undefined };
    },
    setShowRouteTemplatesModal(visible: boolean) {
      self.showRouteTemplatesModal = visible;
    },
    setHoveredShiftID(identifier: string) {
      self.hoveredShiftID = identifier || '';
    },
  }))
  .views((self) => ({
    get getHoveredShiftID(): string {
      return self.hoveredShiftID;
    },
  }));
export default Route;
